import { apiClient } from "./apiClient";
import { endpoints } from "./endpoints";
import type { ApiRecord } from "@/types/api";

/** Reads Platform Certification results only — read-only per ADR-037. */
export const certificationService = {
  async getStatus(): Promise<ApiRecord> {
    const response = await apiClient.get<ApiRecord>(endpoints.certification.status);
    return response.data;
  },
  async getReport(): Promise<ApiRecord> {
    const response = await apiClient.get<ApiRecord>(endpoints.certification.report);
    return response.data;
  },
};
